<template>
  <div>
    <ecoamaps-quote-breakdown v-if="quote.scheme === 'ecoamaps'"
      :quote="quote"
      :quoteCosts="costsForSalarySacrificeQuote"
      :averagePencePerMile="averagePencePerMile"
      :totalEstimatedElectricCostPerMonth="totalEstimatedElectricCostPerMonth"
      :driver-profile="driverProfile"
      :type="carHireType"
      :showFuel="false"
      :show-traditional-cost="true"/>
    <salsac-quote-breakdown v-if="quote.scheme === 'salsac'"
      :quote="quote"
      :quoteCosts="costsForSalarySacrificeQuote"
      :averagePencePerMile="averagePencePerMile"
      :totalEstimatedElectricCostPerMonth="totalEstimatedElectricCostPerMonth"
      :driver-profile="driverProfile"
      :type="carHireType"
      :show-fuel="false"
      :show-traditional-cost="true"/>
    <bch-quote-breakdown v-if="quote.scheme === 'bch' && driverProfile"
      :quote="quote"
      :averagePencePerMile="averagePencePerMile"
      :totalEstimatedElectricCostPerMonth="totalEstimatedElectricCostPerMonth"
      :driverProfile="driverProfile"
      :type="carHireType"
      :adminPortalData="adminPortalData"
    />
  </div>
</template>

<script>
import EcoamapsQuoteBreakdown from "../car-quote/ecoamaps/quote-breakdown";
import SalsacQuoteBreakdown from "../car-quote/salsac/quote-breakdown";
import BchQuoteBreakdown from "../car-quote/bch/quote-breakdown";

export default {
  name: "vehicle-costs",
  components: { EcoamapsQuoteBreakdown, SalsacQuoteBreakdown, BchQuoteBreakdown },
  props: [
    'session',
    'quote',
    'adminPortalData',
    'costsForSalarySacrificeQuote',
    'averagePencePerMile',
    'totalEstimatedElectricCostPerMonth',
    'driver-profile',
    'carHireType'
  ],
}
</script>

<style scoped>

</style>
